import * as React from 'react'
import {
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CRow,
} from '@coreui/react-pro'
import { Divider, Image, Tag } from 'antd'
import { RejectModal } from '../atoms/rejectModal'
import { submitApprove } from './model'
import { path } from '../../../libs'
import { colorCardVerificationStatus } from '../const'
import { useCardVerificationRequest } from './hooks'
import {
  CheckCircleOutlined,
  CloseSquareOutlined,
  FilePdfFilled,
} from '@ant-design/icons'
import { DepositList } from '../atoms/depositsList'

type Props = {
  className?: string
}

const getFileNameFromUrl = (url: string) => {
  // @ts-ignore
  return decodeURI(url?.split('/')?.pop()?.split('?')?.shift())
}

export const CardVerificationDetail = ({ className }: Props) => {
  const card = useCardVerificationRequest()

  return (
    <div>
      <CCard className="mb-4">
        <CCardHeader className="d-sm-flex justify-content-between align-items-center">
          <strong>Client card</strong>
        </CCardHeader>
        <CCardBody>
          <CRow>
            <CCol>
              <strong>User ID:</strong>{' '}
              <a
                target="_blank"
                href={path.clients.details(card.client.clientId)}
              >
                {' '}
                {card.client.clientId}
              </a>
            </CCol>
            <CCol>
              <strong>E-mail:</strong> {card.client.email}
            </CCol>
            <CCol className="d-flex align-items-center gap-2">
              <div>
                <strong>Is verified: </strong>
                {card.client.verified ? (
                  <CheckCircleOutlined className={'text-success'} />
                ) : (
                  <CloseSquareOutlined className={'text-danger'} />
                )}
              </div>
            </CCol>
          </CRow>
          <CRow>
            <CCol xs={4}>
              <strong>Name: </strong>{' '}
              {`${card.client.firstName} ${card.client.lastName}`}
            </CCol>
            <CCol>
              <strong>Country: </strong> {card.client.country}
            </CCol>
            <CCol>
              <div>
                <strong>Is test: </strong>
                {card.client.isTest ? (
                  <CheckCircleOutlined className={'text-success'} />
                ) : (
                  <CloseSquareOutlined className={'text-danger'} />
                )}
              </div>
            </CCol>
          </CRow>
        </CCardBody>
      </CCard>
      <CCard className="mb-4">
        <CCardHeader className="d-sm-flex justify-content-between align-items-center">
          <strong>Card detail</strong>
        </CCardHeader>
        <CCardBody>
          <CRow>
            <CCol>
              <p>
                {' '}
                <strong>Status: </strong>
                <Tag
                  color={colorCardVerificationStatus(card.status)}
                  title={card.status}
                >
                  {card.status}
                </Tag>
              </p>
              <p>
                <strong>Mask:</strong> {card.mask}
              </p>
              <p>
                <strong>Expiration date:</strong> {card.expiry}
              </p>
              <p>
                <strong>Comment:</strong> {card.comment}
              </p>
              <CButton
                color="success"
                className="ms-2"
                onClick={() => {
                  submitApprove({
                    id: card.id,
                    status: card.status,
                  })
                }}
              >
                Approve
              </CButton>
              <RejectModal
                status={card.status}
                requestId={card.id}
                className="ms-2"
              />
              <hr />
            </CCol>
          </CRow>
        </CCardBody>
      </CCard>
      <CCol className={className}>
        <CRow>
          <CCol xs={12}>
            <CCard className="mb-4">
              <CCardHeader className="d-sm-flex justify-content-between align-items-center">
                <strong>Uploaded Documents</strong>
              </CCardHeader>
              <CCardBody
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '12px',
                }}
              >
                {card.browserFileNames?.map((link, index) => {
                  return (
                    <div key={link}>
                      {link.includes('pdf') ? (
                        <div style={{ display: 'flex', gap: '8px' }}>
                          <FilePdfFilled />
                          <a href={link}>{getFileNameFromUrl(link)}</a>
                        </div>
                      ) : (
                        <div className="d-flex flex-column">
                          <Image width={400} src={link} />
                          <a key={link} href={link} target="_blank">
                            doc {index}
                          </a>
                        </div>
                      )}
                    </div>
                  )
                })}
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
      </CCol>

      <CCard className="mb-4">
        <CCardHeader className="d-sm-flex justify-content-between align-items-center">
          <strong>Deposits</strong>
        </CCardHeader>
        <CCardBody>
          {card.id != '' && <DepositList entityId={card.id} />}
        </CCardBody>
      </CCard>
    </div>
  )
}

export const CardVerificationView = () => {
  return (
    <div>
      <CRow>
        <CardVerificationDetail></CardVerificationDetail>
      </CRow>
    </div>
  )
}
